import IconButton from "./IconButton";
import { openModal } from "../../store/slices/modals";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";

const InfoButton: React.FC<{}> = () => {
  const dispatch = useAppDispatch();
  const { available, disabled } = useAppSelector(
    selectButton.bind(null, "info")
  );
  const onClick = () => dispatch(openModal("info"));

  return (
    <IconButton
      available={available}
      onClick={onClick}
      name="info"
      disabled={disabled}
      type="Info"
      soundEffect="button-click"
    />
  );
};

export default InfoButton;
